import { render, staticRenderFns } from "./RideitInvitationsStatus.vue?vue&type=template&id=56b706e4&scoped=true"
import script from "./RideitInvitationsStatus.vue?vue&type=script&lang=ts"
export * from "./RideitInvitationsStatus.vue?vue&type=script&lang=ts"
import style0 from "./RideitInvitationsStatus.vue?vue&type=style&index=0&id=56b706e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b706e4",
  null
  
)

export default component.exports